export default {
    methods: {
        formatOp(op) {
            const labels = {
                in: 'is',
                not_in: 'is not',
                is: 'is',
                is_not: 'is not',
                eq: 'is',
                neq: 'is not',
                is_between: 'is between',
                is_on: 'is on',
                is_before: 'is before',
                is_after: 'is after',
                contains: 'contains',
                not_contains: 'does not contain',
                equals: 'equals',
                not_equals: 'does not equal',
                greater_than: 'greater than',
                gt: 'greater than',
                less_than: 'less than',
                lt: 'less than',
                between: 'between',
                gte: 'greater than or equal to',
                lte: 'less than or equal to',
            };

            return labels[op] || op;
        },
    },
};



// WEBPACK FOOTER //
// ./src/Assets/mixins/operatorLabels.js